import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-banner"
}
const _hoisted_2 = { class: "container-fluid position-relative" }
const _hoisted_3 = ["innerHTML"]

import { library } from '@fortawesome/fontawesome-svg-core';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import {
  onBeforeMount,
  onMounted,
  ref,
  computed,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageBanner',
  setup(__props) {

library.add(faXmark);

const pageBanner = window.ioappConfig.pageBanner[0];

const { content } = pageBanner;
const { shown } = pageBanner;
const startDate = pageBanner.start;
const endDate = pageBanner.end;

const isOpen = ref(true);
const inDateRange = ref(true);

const isInDateRange = () => {
  const today = new Date();
  if (startDate && endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    inDateRange.value = today >= start && today <= end;
  } else {
    inDateRange.value = false;
  }
};

const inSession = sessionStorage.getItem('banner') === 'true' && shown === 'session';

const show = computed(() => content && (inDateRange.value && !inSession) && isOpen.value);
onBeforeMount(() => {
  isInDateRange();
});

onMounted(() => sessionStorage.setItem('banner', 'true'));

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (show.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", { innerHTML: _unref(content) }, null, 8, _hoisted_3),
          _createElementVNode("div", null, [
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = false))
            }, [
              _createVNode(_component_FontAwesomeIcon, { icon: _unref(faXmark) }, null, 8, ["icon"])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})